document.addEventListener("DOMContentLoaded", function() {
  const watchVideoButton = document.getElementById("watch-video-button");

  watchVideoButton.addEventListener("click", function() {
    const videoCover = document.getElementById("how-nomad-works-video-right-cover");
    if (videoCover) {
      videoCover.style.display = "none";
    }

    const videoIframe = document.querySelector(".how-nomad-works-video-right iframe");
    if (videoIframe) {
      videoIframe.style.opacity = "1";
      videoIframe.style.pointerEvents = "all";
      videoIframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
    }

    watchVideoButton.style.display = "none";
  });
});
